import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

interface EditWarningDialogProps {
  open: boolean;
  onClose: () => void;
  onProceed: () => void;
  title?: string;
  message?: string;
}

/**
 * Reusable Edit Warning Dialog Component
 * 
 * Shows a warning dialog when entering edit mode.
 * Can be customized with title and message props.
 */
const EditWarningDialog: React.FC<EditWarningDialogProps> = ({
  open,
  onClose,
  onProceed,
  title = 'Important',
  message = 'Please modify the database carefully and adhere to the data types of those columns. For reference, check old records before entering values. Currently there are no constraint checks, so please don\'t mess up the database.',
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">Cancel</Button>
        <Button onClick={onProceed} variant="contained" color="primary">
          Proceed
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditWarningDialog;

